import "./assets/scss/socialv.scss"
import "./assets/scss/customizer.scss"
import './App.css';
import { useDispatch } from 'react-redux';
import { setSetting } from './store/setting/actions'
import { useEffect, useState } from "react";
import axios from "axios";
import Maintenance from "./views/dashboard/extrapages/maintenance";
import ReactGA from "./analytics";
import { useLocation } from "react-router-dom";

function App(props) {
  const location = useLocation();
  const dispatch = useDispatch()
  // dispatch(setSetting())

  useEffect(() => {
    ReactGA.send({ hitType: "pageview", page: location.pathname + location.search });
  }, [location]);
  
  const [isMaintenance, setIsMaintenance] = useState(false);


  useEffect(() => {
    dispatch(setSetting());

    const fetchMaintenanceStatus = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_URL}/api/default-setting/footer?status=true`
      );
      // console.log("footer fetched", response?.data?.data?.enableMaintenanceMode?.enableMaintenanceMode);
      if (response?.data?.data?.enableMaintenanceMode?.enableMaintenanceMode === 'enable') {
        setIsMaintenance(true);
      }
    } catch (error) {
      console.error("Failed Fetching dropdown", error);
    }
  };
  fetchMaintenanceStatus();
}, [dispatch]);

if (isMaintenance) {
  return (
    <Maintenance/>
  );
}

  return (
    <div className="App">
      {/* <IndexRouters /> */}
      {props.children}
    </div>
  );
}

export default App;
